import { scheduleCoordinator } from '../../../services/scheduling/schedule-coordinator';
import { PriorRunContext } from '../../../utils/rerun-canonical';

/**
 * How recent a prior run must be for its card to be trusted without asking the edge: FIX-2's
 * `uploadCheckAfterMinutes` default (PLAN C3, 60). Past it the output may have been cleaned up, and
 * offering a download of a result that is gone is what UX-SPEC 8.6 forbids -- so an older run is
 * simply "run normally".
 */
export const RERUN_FRESH_MINUTES = 60;

/**
 * A running card reports progress several times a second (`FileManagerService.fileUploadChanged`); the surfaces
 * re-answer "unchanged?" on the state those frames settle on, not on every one.
 */
export const RERUN_CARD_CHANGE_DEBOUNCE_MS = 150;

/** The clock, the fresh window and the hands-off scheduler's view of a card, for `priorRunState`. */
export function rerunContext(now: number = Date.now()): PriorRunContext {
    return {
        now,
        freshMinutes: RERUN_FRESH_MINUTES,
        queuedStatus: (id: string) => (scheduleCoordinator.enabled ? scheduleCoordinator.view(id)?.status ?? null : null),
    };
}

/** Per-instance ids for the live regions (f9d719831: "per-instance region ids"). */
let seq = 0;
export function nextRerunRegionId(prefix: string): string {
    seq += 1;
    return `${prefix}-${seq}`;
}
